



















import Vue from "vue";
import GaIcon from "./GaIcon.vue";
import { SIZE, useGenAiPalette } from "../data/design";

/** gen-ai-ui `CountColumnHeader`: an icon over the count column, named on hover */
export default Vue.extend({
  components: { GaIcon },
  props: {
    /** "Activities" or "Employees" */
    label: { type: String, required: true },
    /** "activity" for activity counts, "users" for people */
    icon: { type: String, default: "activity" },
  },
  setup() {
    return { T: useGenAiPalette(), S: SIZE };
  },
});
